import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ClockBIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M9 3.24V9H14.76M3.24 9H4.06286M9 14.76V13.9371M17.2286 9C17.2286 13.5445 13.5445 17.2286 9 17.2286C4.45549 17.2286 0.771429 13.5445 0.771429 9C0.771429 4.45549 4.45549 0.771429 9 0.771429C13.5445 0.771429 17.2286 4.45549 17.2286 9Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

ClockBIcon.displayName = 'ClockBIcon';
